import { create } from 'zustand';

interface DialogStore {
  dialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
  headerText: string;
  setHeaderText: (text: string) => void;
  headerIcon: string;
  setHeaderIcon: (icon: string) => void;
  setCartStatus: (status: status) => void; // 添加 setter 函数
}

type status = 'cartopen' | 'addtocart';

export const useMiniCartStore = create<DialogStore>(set => ({
  dialogOpen: false,
  setDialogOpen: open =>
    set({
      dialogOpen: open,
    }),
  headerText: 'Added to Cart!',
  setHeaderText: text =>
    set({
      headerText: text,
    }),
  headerIcon: 'cart',
  setHeaderIcon: icon =>
    set({
      headerIcon: icon,
    }),
  setCartStatus: (status: status) =>
    set(() => {
      // 根据 status 批量更新多个状态
      switch (status) {
        case 'cartopen':
          return {
            cartStatus: status,
            dialogOpen: true,
            headerText: 'Added to Cart!',
            headerIcon: '',
          };
        case 'addtocart':
          return {
            cartStatus: status,
            dialogOpen: true,
            headerText: 'ITEM ADDED TO CART!',
            headerIcon: 'add',
          };
        default:
          return {
            cartStatus: status,
          };
      }
    }),
}));
